function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import App from 'modules/App';
import * as constants from '../../../constants';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import ProfileBox from '../ProfileBox';
import PasswordForm from './PasswordForm';
var _React_PureComponent;
class PasswordModal extends (_React_PureComponent = React.PureComponent) {
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.IDENTITY_PASSWORD_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: messages.headers.identityPassword,
            isInProgress: this.props.isInProgress,
            onClose: this.props.onClose,
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "modal__info",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.identityPassword))
                }),
                /*#__PURE__*/ _jsx(ProfileBox, {
                    identity: this.props.identity
                }),
                /*#__PURE__*/ _jsx(PasswordForm, {
                    isInProgress: this.props.isInProgress,
                    onSubmit: ({ password })=>this.props.onSwitch(password),
                    onCancel: this.props.onClose
                })
            ]
        });
    }
}
_define_property(PasswordModal, "propTypes", {
    // Explicit props
    identity: shapes.identity,
    isInProgress: PropTypes.bool,
    // Explicit actions
    onSwitch: PropTypes.func.isRequired,
    // Implicit props
    openModalId: PropTypes.string,
    // Implicit actions
    onClose: PropTypes.func
});
const mapStateToProps = (state)=>({
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onClose: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedPasswordModal = connect(mapStateToProps, mapDispatchToProps)(PasswordModal);
export default ConnectedPasswordModal;
